import { render } from "./Navbar.vue?vue&type=template&id=54bb75e0"
import script from "./Navbar.vue?vue&type=script&lang=ts"
export * from "./Navbar.vue?vue&type=script&lang=ts"
script.render = render

export default script